/**
 * About Tab - Sobre o Sistema
 */

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ExternalLink, Mail, MessageCircle, BookOpen, Shield, FileText } from "lucide-react";

export function AboutTab() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>ℹ️ Informações do Sistema</CardTitle>
          <CardDescription>
            Detalhes sobre a versão e atualizações
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Nome do Sistema</p>
              <p className="text-sm text-muted-foreground">SisCuca - Sistema de Gestão</p>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Versão</p>
              <p className="text-sm text-muted-foreground">1.0.0</p>
            </div>
            <Badge variant="secondary">Estável</Badge>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Última Atualização</p>
              <p className="text-sm text-muted-foreground">Janeiro 2025</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>💬 Suporte e Ajuda</CardTitle>
          <CardDescription>
            Precisa de ajuda? Estamos aqui para você
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button variant="outline" className="w-full justify-start gap-2" asChild>
            <a href="https://wa.me/5511999999999" target="_blank" rel="noopener noreferrer">
              <MessageCircle className="w-4 h-4" />
              Fale conosco pelo WhatsApp
              <ExternalLink className="w-3 h-3 ml-auto" />
            </a>
          </Button>

          <Button variant="outline" className="w-full justify-start gap-2" asChild>
            <a href="mailto:suporte@siscuca.com.br">
              <Mail className="w-4 h-4" />
              Enviar e-mail para suporte
              <ExternalLink className="w-3 h-3 ml-auto" />
            </a>
          </Button>

          <Button variant="outline" className="w-full justify-start gap-2" asChild>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <BookOpen className="w-4 h-4" />
              Base de conhecimento
              <ExternalLink className="w-3 h-3 ml-auto" />
            </a>
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>📄 Legal</CardTitle>
          <CardDescription>
            Termos, privacidade e políticas
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button variant="outline" className="w-full justify-start gap-2" asChild>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <Shield className="w-4 h-4" />
              Política de Privacidade
              <ExternalLink className="w-3 h-3 ml-auto" />
            </a>
          </Button>

          <Button variant="outline" className="w-full justify-start gap-2" asChild>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FileText className="w-4 h-4" />
              Termos de Uso
              <ExternalLink className="w-3 h-3 ml-auto" />
            </a>
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6 text-center space-y-2">
          <p className="text-sm text-muted-foreground">
            Feito com ❤️ para confeiteiros e boleiros
          </p>
          <p className="text-xs text-muted-foreground">
            © 2025 SisCuca. Todos os direitos reservados.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
